import { render, staticRenderFns } from "./VehicleLicensePartial.vue?vue&type=template&id=71ff41c7"
import script from "./VehicleLicensePartial.vue?vue&type=script&lang=js"
export * from "./VehicleLicensePartial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports